module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_114_14.9e7ad22e.pdf";